










































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import BpcInputGroup from '@shared/components/forms/inputs/input-group/input-group.vue';
import BpcSwitch from '@shared/components/forms/inputs/switch/switch.vue';
import Textarea from '@shared/components/forms/inputs/textarea/textarea.vue';

@Component({
  name: 'bpc-pos-fmi-add-passage-modal',
  components: {
    BpcInputGroup,
    BpcSwitch,
    'bpc-textarea': Textarea,
  },
})
export default class PosFmiAddPassageModal extends Vue {
  // PROPS
  @Prop({ type: Boolean, default: false }) readonly showModal: boolean;
  @Prop({
    type: Number,
    required: true,
  })
  readonly posSessionId!: number;
  @Prop({
    type: Number,
    required: true,
  })
  readonly selectedResourceId: number;
  // DATA
  loading = false;
  numberOfPassages = 1;
  isIn = true;
  comment = '';

  // COMPUTED
  // LIFECYCLE
  // METHODS

  closeModal() {
    this.resetModal();
    this.$emit('close-modal');
    this.numberOfPassages = 1;
    this.isIn = true;
    this.comment = '';
  }

  resetModal() {
    this.loading = false;
  }

  async onConfirm() {
    if (!this.comment) {
      this.$bpcMessage.showErrorMessage({ text: 'pos.error.comment_required' });
    } else {
      this.loading = true;
      try {
        await this.$posService.createAccessControlEvent(
          this.posSessionId,
          this.numberOfPassages,
          this.selectedResourceId,
          this.isIn,
          this.comment,
        );
        this.closeModal();
      } catch (error) {
        this.$bpcMessage.showErrorMessage({ text: 'pos.error.add_access_control_event' });

        this.loading = false;
      }
    }
  }
  // WATCHERS
}
